// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";

export interface TotalRewardsStatisticsCardProps {
    title: React.ReactNode;
    value: number | undefined;
}
type Props = TotalRewardsStatisticsCardProps;

interface TotalRewardsStatisticsCardStyles {
    cardContainer?: InjectableCss;
    title?: TypographyPresentationProps;
    value?: TypographyPresentationProps;
}

export const totalRewardsStatisticsCardStyles: TotalRewardsStatisticsCardStyles = {};

const styles = totalRewardsStatisticsCardStyles;

const TotalRewardsStatisticsCard: React.FC<Props> = ({ title, value }) => {
    return (
        <StyledWrapper {...styles.cardContainer}>
            <Typography {...styles.title}>{title}</Typography>
            <Typography {...styles.value}>${value?.toFixed(2)}</Typography>
        </StyledWrapper>
    );
};

export default TotalRewardsStatisticsCard;
